import React from 'react';
import { Mail, Phone, Users } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { firmInfo } from '../../i18n/translations';

const Team = ({ t }) => {
  // Map team member names to their profile photos
  const getProfilePhoto = (memberName) => {
    const photoMap = {
      'Doris Sessolo': '/doris.png',
      'Christophe Cogels': '/christophe.png',
      'Michel Caldana': '/michel.png'
    };
    return photoMap[memberName] || null;
  };

  return (
    <section id="team" className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-navy-900 mb-4">{t.team.title}</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {t.team.members.map((member, index) => {
            const memberInfo = firmInfo.teamMembers[index];
            const photoUrl = getProfilePhoto(member.name);
            
            return (
              <Card key={member.name} className="border-navy-100">
                <CardHeader className="text-center pb-4">
                  <div className="w-32 h-32 rounded-full mx-auto mb-6 overflow-hidden bg-navy-100">
                    {photoUrl ? (
                      <img 
                        src={photoUrl} 
                        alt={member.name}
                        className="w-full h-full object-cover"
                        style={member.name === 'Michel Caldana' ? { objectPosition: 'center 75%' } : {}}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <Users className="h-16 w-16 text-navy-600" />
                      </div>
                    )}
                  </div>
                  <CardTitle className="text-2xl text-navy-900">{member.name}</CardTitle>
                  <CardDescription className="text-lg text-navy-600 font-semibold">
                    {member.role}
                  </CardDescription>
                </CardHeader>
                <CardContent className="text-center">
                  <div className="text-gray-700 mb-6 leading-relaxed text-left whitespace-pre-line">
                    {member.bio}
                  </div>
                  <div className="flex flex-col gap-3 items-center">
                    {memberInfo.email && (
                      <a href={`mailto:${memberInfo.email}`} className="flex items-center gap-2 text-navy-600 hover:text-navy-700 text-sm">
                        <Mail className="h-4 w-4" />
                        <span>{memberInfo.email}</span>
                      </a>
                    )}
                    {memberInfo.phone && (
                      <a href={`tel:${memberInfo.phone}`} className="flex items-center gap-2 text-navy-600 hover:text-navy-700 text-sm">
                        <Phone className="h-4 w-4" />
                        <span>{memberInfo.phone}</span>
                      </a>
                    )}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Team;